import { boot } from 'quasar/wrappers'
import { i18n } from './i18n'
const { t } = i18n.global

export default boot(({ app, router }) => {
  const ErrorHandler = {
    process: (message, error) => {
      return new Promise((resolve, reject) => {
        const status = error?.response?.status

        if (error.hasOwnProperty('response')) {
          if (error.response === undefined) {
            resolve(ErrorHandler.throwNoNetwork(message, error))
          } else if (status === 401) {
            // ********************* NO SESSION
            resolve(ErrorHandler.throwSessionExpired(message, error))
          } else if (status === 404) {
            // ********************* BAD CREDENTIALS
            resolve(ErrorHandler.throwBadCredentials(message, error))
          } else if (status === 403) {
            const data = error.response.data
            const errors = Array.isArray(data) ? data : data?.errors ?? []
            const isMigratedOrForbidden = errors.some(
              (e) => e?.code === 'MIGRATED'
            )
            if (isMigratedOrForbidden) {
              resolve(ErrorHandler.throwMigratedUser(message, error))
            } else {
              resolve(ErrorHandler.throwUnmanaged(message, error))
            }
          } else {
            resolve(ErrorHandler.throwUnmanaged(message, error))
          }
        } else if (error.hasOwnProperty('data')) {
          if (error.data.title === 'Unauthorized') {
            // ********************* NO SESSION AGAIN
            resolve(ErrorHandler.throwSessionExpired(message, error))
          } else if (error.data.title === 'Not Found') {
            resolve(ErrorHandler.throwNotFound(message, error))
          } else {
            resolve(ErrorHandler.throwUnmanaged(message, error))
          }
        } else {
          if (error.hasOwnProperty('0') && error[0].hasOwnProperty('title')) {
            if (error[0]['title'].startsWith('duplicate detected')) {
              resolve(ErrorHandler.suppressErrors(message, error))
            } else if (error[0]['title'] == 'Resource not found') {
              resolve(ErrorHandler.throwNonExistingElement(error))
            } else {
              resolve(ErrorHandler.throwJsonApiErrors(message, error))
            }
          } else {
            resolve(ErrorHandler.throwUnproceseable(message, error))
          }
        }
      })
    },
    throwUnmanaged: (message, error) => {
      app.config.globalProperties.$q.loading.hide()
      app.config.globalProperties.$q.notify({
        message: t('common.error.unmanagedError'),
        type: 'warning',
        position: 'top'
      })
      router.replace({ path: '/login' })
      return error
    },
    throwNotFound: (message, error) => {
      app.config.globalProperties.$q.loading.hide()
      return error
    },
    throwUnproceseable: (message, error) => {
      app.config.globalProperties.$q.loading.hide()
      let currentMessage = t('common.error.unproceseableError')
      if (message.length) {
        currentMessage = message
      }
      app.config.globalProperties.$q.notify({
        message: currentMessage,
        type: 'warning',
        position: 'top'
      })
      return error
    },
    throwJsonApiErrors: (message, error) => {
      const errorToArray = Object.values(error)
      const idIssues = errorToArray.map((err) => err.title.split('of ')[1])
      app.config.globalProperties.$q.loading.hide()
      let currentMessage = t('common.error.unproceseableError')
      if (message.length) {
        currentMessage = t('common.error.throwJsonApiErrors', {
          message,
          idIssues: idIssues.toString()
        })
      }
      app.config.globalProperties.$q.notify({
        message: currentMessage,
        type: 'warning',
        position: 'top'
      })
      return error
    },
    throwNoSession: (message, error) => {
      app.config.globalProperties.$q.loading.hide()
      return error
    },
    throwSessionExpired: (message, error) => {
      app.config.globalProperties.$q.loading.hide()
      app.config.globalProperties.$q.notify({
        message: t('common.error.SessionExpired'),
        type: 'warning',
        position: 'top'
      })
      return error
    },
    throwBadCredentials: (message, error) => {
      app.config.globalProperties.$q.loading.hide()
      app.config.globalProperties.$q.notify({
        message: t('login.loginFailed'),
        type: 'warning',
        position: 'top'
      })
      return error
    },
    throwMigratedUser: (message, error) => {
      app.config.globalProperties.$q.loading.hide()
      app.config.globalProperties.$q.notify({
        message: t('login.accountMigratedToV2'),
        type: 'warning',
        position: 'top'
      })
      router.replace({ path: '/login' })
      return error
    },
    throwNoNetwork: (message, error) => {
      app.config.globalProperties.$q.loading.hide()
      if (navigator.onLine) {
        app.config.globalProperties.$q.notify({
          message: t('common.error.NoNetwork'),
          type: 'warning',
          position: 'top'
        })
      }
      return error
    },
    throwNonExistingElement: (error) => {
      app.config.globalProperties.$q.loading.hide()
      console.error(error)
      return error
    },
    suppressErrors: (message, error) => {
      app.config.globalProperties.$q.loading.hide()
      const errorToArray = Object.values(error)
      const idIssues = errorToArray.map((err) => err.title.split('of ')[1])
      app.config.globalProperties.$q.notify({
        message: t('common.error.suppressErrors', {
          message,
          idIssues: idIssues.toString()
        }),
        type: 'warning',
        position: 'top',
        timeout: 6000
      })
      return error
    }
  }

  app.config.globalProperties.$ErrorHandler = ErrorHandler
})
